export default {
	// Custom Page Meta
	seo_meta_title_leaguepass: 'League Pass: ve los partidos de la NBA en directo | NBA.com',
	seo_meta_desc_leaguepass: 'En directo o a la carta: elige cómo quieres vivir los partidos de la NBA con el League Pass. Accede a tu cuenta aquí.',
	seo_meta_keywords_leaguepass: 'Videos de la NBA, puntos destacados de la NBA, videos de baloncesto, mejores jugadas, mates, características',
	seo_meta_title_featured: 'Todos los partidos y los mejores momentos de la NBA | NBA.com',
	seo_meta_desc_featured: 'Accede gratis a vídeos, noticias y análisis de la NBA. Descubre también las suscripciones a NBA TV y al League Pass para ver partidos en directo en tus dispositivos favoritos.',
	seo_meta_keywords_featured: '',
	seo_meta_title_nbatv: 'NBA TV: emisión de partidos en directo y cobertura las 24 horas del día | NBA.com',
	seo_meta_desc_nbatv: 'Con NBA TV, ve partidos en directo o los encuentros clásicos más emblemáticos. DIsfruta también de programas de televisón y análisis de toda la liga.',
	seo_meta_keywords_nbatv: 'Canal NBA TV, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, studio shows, the jump',
	seo_meta_title_classicgames: 'Vuelve a ver partidos clásicos y mucho más con NBA TV | NBA.com',
	seo_meta_desc_classicgames: 'Vive la emoción de los partidos clásicos más emblemáticos con NBA TV. Disfruta también de encuentros en directo, programas de televisón y análisis de toda la liga.',
	seo_meta_keywords_classicgames: '',
	seo_meta_pre_title_videolist: 'Accede al contenido aquí | NBA.com',
	seo_meta_title_videolist: 'Accede a {0} aquí | NBA.com',
	seo_meta_desc_videolist: 'Accede a los vídeos de {0} aquí. Descubre también las suscripciones a NBA TV y al League Pass para ver partidos en directo en tus dispositivos favoritos.',
	seo_meta_title_videolist_show: 'Accede a {0} con NBA TV | NBA.com',
	seo_meta_desc_videolist_show: 'Accede a {0} aquí. Disfruta también de encuentros en directo en NBA TV, partidos clásicos y análisis.',
	seo_meta_keywords_videolist_show: '',
	seo_meta_title_videolist_feed: 'Accede a {0} aquí | NBA.com',
	seo_meta_desc_videolist_feed: 'Accede a los vídeos de {0} aquí. Descubre también las suscripciones a NBA TV y al League Pass para ver partidos en directo en tus dispositivos favoritos.',
	seo_meta_keywords_videolist_feed: '',
	seo_meta_keywords_videolist: '',
	seo_meta_title_shows: 'Ve programas de televisión y mucho más con NBA TV | NBA.com',
	seo_meta_desc_shows: 'No te pierdas los últimos episodios y programas de televisión de NBA TV a la carta. Disfruta también de encuentros en directo, partidos clásicos y análisis.',
	seo_meta_keywords_shows: '',
	// Common Page Meta
	seo_meta_title_home: 'Inicio | NBA.com',
	seo_meta_desc_home: '',
	seo_meta_keywords_home: '',
	seo_meta_title_channels: 'Canales | NBA.com',
	seo_meta_desc_channels: '',
	seo_meta_keywords_channels: '',
	seo_meta_pre_title_channel: 'Canal | NBA.com',
	seo_meta_pre_title_categories: 'Categorías | NBA.com',
	seo_meta_title_categories: 'Categorías | NBA.com',
	seo_meta_desc_categories: '',
	seo_meta_keywords_categories: '',
	seo_meta_pre_title_category: 'Categoría | NBA.com',
	seo_meta_title_category: 'Categoría | NBA.com',
	seo_meta_desc_category: '',
	seo_meta_keywords_category: '',
	seo_meta_pre_title_video: 'Accede al vídeo aquí | NBA.com',
	seo_meta_pre_title_event: 'Accede al evento aquí | NBA.com',
	seo_meta_title_events: 'Eventos | NBA.com',
	seo_meta_desc_events: '',
	seo_meta_keywords_events: '',
	seo_meta_title_event: 'Accede a {0} aquí | NBA.com',
	seo_meta_desc_event: 'Accede a {0} aquí. Descubre también las suscripciones a NBA TV y al League Pass para ver partidos en directo en tus dispositivos favoritos.',
	seo_meta_keywords_event: '',
	seo_meta_title_search: 'Buscar | NBA.com',
	seo_meta_desc_search: '',
	seo_meta_keywords_search: '',
	seo_meta_title_notfound: 'Página no encontrada | NBA.com',
	seo_meta_desc_notfound: '',
	seo_meta_keywords_notfound: '',
	seo_meta_pre_title_game: 'Ve el partido aquí | NBA.com',
	seo_meta_title_game: 'Accede a {0} aquí | NBA.com',
	seo_meta_desc_game: 'Accede a {0} aquí. Descubre también las suscripciones a NBA TV y al League Pass para ver partidos en directo en tus dispositivos favoritos.',
	seo_meta_keywords_game: '',
	seo_meta_title_video: 'Accede a {0} aquí | NBA.com',
	seo_meta_desc_video: 'Accede a {0} aquí. Descubre también las suscripciones a NBA TV y al League Pass para ver partidos en directo en tus dispositivos favoritos.',
	seo_meta_keywords_video: 'vídeos de la NBA, resúmenes de la NBA, vídeos de baloncesto, mejores jugadas, mates, destacados',
	seo_meta_title_episode: 'Accede a {0} con NBA TV | NBA.com',
	seo_meta_desc_episode: 'Accede a {0} aquí. Disfruta también de encuentros en directo en NBA TV, partidos clásicos y análisis.',
	seo_meta_keywords_episode: 'vídeos de la NBA, resúmenes de la NBA, vídeos de baloncesto, mejores jugadas, mates, destacados',
	seo_meta_title_channel: 'NBA TV en directo | NBA.com',
	seo_meta_desc_channel: 'NBA TV Live es tu transmisión en vivo, 24 horas al día, del canal NBA TV que emite partidos en vivo y de archivo de la NBA cada semana, programas de estudio y cobertura de analistas',
	seo_meta_keywords_channel: 'Canal NBA TV, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, studio shows, the jump',
	seo_meta_title_tvguide: 'Programación de emisiones en directo de NBA TV | NBA.com',
	seo_meta_desc_tvguide: 'Echa un vistazo a la programación de NBA TV para saber cuándo ponen en directo partidos y programas de televisión que te interesen y poder verlos en tu dispositivo favorito. Accede también a programas y análisis a la carta.',
	seo_meta_keywords_tvguide: 'Canal NBA TV, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, studio shows, the jump',

	// Common
	timezone: 'ET',
	default_feed_error_message: 'Algo salió mal, el contenido no está disponible ahora. Intenta más tarde.',
	watch_in_app: 'MÍRALO EN LA APP DE NBA',
	ad_blocked_message: 'Bloqueador de anuncios detectado: el contenido de NBA.com solo es posible gracias al apoyo de los anunciantes. Para seguir disfrutando de nuestro contenido, desactiva tu bloqueador de anuncios.',

	// Item
	no_content: 'Sin contenido',
	see_more: 'Ver más',
	now_playing: 'EN REPRODUCCIÓN',
	nba_tv_lock: 'NBA TV',
	league_pass_lock: 'League Pass',
	league_pass_premium_lock: 'LP PREMIUM',
	error_max_limit_favorite: 'Haz alcanzado el número máximo de videos favoritos. Elimina algunos antes de añadir más.',
	item_live: 'EN VIVO',
	add_favourite_title: 'AGREGAR A FAVORITOS',
	remove_favourite_title: 'QUITAR DE FAVORITOS',
	// Channel: Schedule
	p_channel_live: 'EN VIVO',
	p_channel_schedule_title: 'Programación NBA TV',
	p_channel_schedule_watch: 'Ver',
	p_channel_live24x7_title: 'NBA TV 24/7',
	p_channel_live24x7_see_full_schedule: 'Ver programación completa',
	p_channel_live24x7_up_next: 'A continuación',
	p_channel_live24x7_on_demand: 'NBA TV: On Demand',
	p_channel_live24x7_collection: 'Colección',
	p_channel_live24x7_demand_1_logo_text: 'Shows originales',
	p_channel_live24x7_demand_1_show_name: 'Shows de NBA TV',
	p_channel_live24x7_demand_1_show_desc: 'Programas originales de NBA TV que incluyen Shaqtin’a Fool, Beyond the Paint, Game Time y Basketball Stories',
	p_channel_live24x7_demand_2_logo_text: 'Partidos clásicos',
	p_channel_live24x7_demand_2_show_name: 'NBA | Juegos clásicos',
	p_channel_live24x7_demand_2_show_desc: 'Mira partidos clásicos completos, incluidos todas las finales desde 2000, momentos históricos de la liga y jugadores legendarios',

	// Channel: Clips
	p_channel_error_msg: 'Aún no está disponible',

	// Channel: detail
	p_channel_category_title: 'NBA TV',
	p_channel_playlist_title: 'Programación',

	// NBA TV Shows:
	p_nba_tv_shows: 'Programas de NBA TV',
	p_nba_tv_no_access_title: 'NBA 24/7: ¡Mantente informado con análisis de partidos, análisis desde el estudio, programación original y más!',
	p_nba_tv_no_access_desc: 'Mira partidos en vivo, además de programas especiales y partidos clásicos on demand.',
	p_nba_tv_no_access_note: 'Se pueden aplicar fechas de restricción a nivel regional',

	// tv show item
	tv_show_item_latest_episode: 'Último episodio',
	tv_show_item_no_latest_episode: 'Sin último episodio',
	see_all: 'Ver todo',
	// header
	header_menu_watch: 'Ver',
	header_menu_featured: 'Destacado',
	header_menu_nba_tv: 'NBA TV',
	header_menu_league_pass: 'League Pass',

	// search
	players: 'Jugadores',
	videos: 'Videos',
	teams: 'Equipos',
	most_searched: 'MÁS BUSCADOS',
	no_result: 'Sin datos',
	search_filter_type_most_relevant: 'Lo más relevante',
	search_filter_type_most_viewed: 'Más visto',
	search_filter_type_most_recent: 'Lo más reciente',
	search_filter_type_last_30_days: 'Últimos 30 días',
	search_filter_type_last_6_months: 'Últimos 6 meses',
	search_result_label: 'Resultados de la búsqueda para \'{keyword}\'',
	search_result_info: 'Ver todos los resultados para {keyword}',
	search_placeholder: 'Buscar en la biblioteca de videos',
	load_more: 'Carga más...',

	// button
	button_subscribe: 'Suscribir',
	button_sign_in: 'Iniciar sesión',
	button_tv_provider: 'Seleccionar proveedor de TV',

	// league page
	p_league_pass_no_access_title: '¡Mira partidos en vivo o en repetición en cualquier dispositivo, incluidos tu computadora, teléfono y TV!',
	p_league_pass_no_access_desc: 'Tu boleto a la acción: mira toda la liga o tu equipo favorito, elige un solo partido o mira más opciones.',
	p_league_pass_no_access_note: 'Se aplican términos y condiciones',

	// Video
	category_title: 'Video',
	p_video_playlist_title: 'Lista de reproducción',
	p_video_episode_text: 'Episodio',
	p_no_access_league_pass_title: 'Desbloquear NBA League Pass para mirar:',
	p_no_access_league_pass_premium_title: 'Unlock NBA League Pass Premium to watch:',
	p_no_access_league_pass_desc: 'Tu boleto a la acción: mira toda la liga o tu equipo favorito, elige un solo partido o mira más opciones.',
	p_no_access_league_pass_terms: 'Se aplican términos y condiciones',
	p_no_access_league_pass_geo_desc: 'Según tu ubicación actual, no puedes ver este partido a través de NBA League Pass y NBA TV. Un archivo de estos partidos estará disponible 3 días después de la transmisión para los suscriptores de NBA League Pass. Consulta los horarios de las emisoras de radio y televisión locales para saber dónde encontrar las transmisiones en tu zona.',
	p_no_access_league_pass_not_found_desc: 'Lo sentimos, no se encontró el video que solicitaste.',
	p_no_access_event_geo_desc: 'Esta transmisión no está disponible para los aficionados que vivan en Estados Unidos o Canadá. Se puede ver en ESPN en EE. UU. y en TSN o Sportsnet en Canadá.',
	p_no_access_event_not_found_desc: 'Lo sentimos, no se encontró el evento que solicitaste.',
	p_no_access_nba_tv_title: 'Desbloquea NBA TV para mirar:',
	p_no_access_nba_tv_desc: 'Mira partidos en vivo, además de programas y partidos clásicos on demand.',
	p_no_access_nba_tv_terms: 'Se aplican términos y condiciones',
	p_no_access_nba_tv_geo_desc: 'Según tu ubicación actual, no puedes ver este partido a través de NBA League Pass y NBA TV. Un archivo de estos partidos estará disponible 3 días después de la transmisión para los suscriptores de NBA League Pass. Consulta los horarios de las emisoras de radio y televisión locales para saber dónde encontrar las transmisiones en tu zona.',
	p_no_access_nba_tv_not_found_desc: 'Lo sentimos, no se encontró el canal que solicitaste.',
	p_no_access_up_next: 'A continuación:',
	p_video_completed_title: 'Lista de reproducción completa',
	p_video_completed_desc: 'Vuelve a navegar o echa un vistazo a la siguiente lista de reproducción',
	p_video_share_to: 'Compartir en:',
	p_video_more_to_watch: 'Más para ver:',

	// Event
	p_event_section_title: 'EVENTO',
	p_event_playlist_title: 'Lista de reproducción',
	p_event_button_watch: 'Ver',
	p_event_button_listen: 'Escuchar',
	p_event_button_ticket: 'Boleto',

	// notfound page
	notfound: 'Lo sentimos, no se encontró la página que solicitaste.',
	notfound_desc: 'Comprueba si la URL es correcta. <br/> También puedes buscar el contenido que desees utilizando el mapa del sitio o la herramienta de búsqueda.',

	// Modal - PCM
	modal_pcm_header_title: '',
	modal_pcm_body_title: '',
	modal_pcm_body_description: 'Tu cuenta de NBA League Pass ha alcanzado su número de transmisiones máximo. Toca \'Continuar\' para seguir viendo en este dispositivo.',
	modal_pcm_custom: 'Continuar',
	modal_pcm_close: 'Cancelar',
	modal_pcm_ok: 'ACEPTAR',

	// Modal - Unsupported
	modal_video_unsupported_header_title: '',
	modal_video_unsupported_body_title: '',
	modal_video_unsupported_body_description: 'Este video no se puede reproducir en tu dispositivo. Haz clic <a href=\'https://neulion-a.akamaihd.net/nlweb/h5support/player.html\' target=\'_blank\'>AQUÍ</a> para obtener más ayuda.',
	modal_video_unsupported_custom: '',
	modal_video_unsupported_close: 'ACEPTAR',
	modal_video_unsupported_ok: 'ACEPTAR',

	// FreeSample
	freesample_notice_time: 'Tiempo restante',
	freesample_notice_title: 'Disfruta tus {0} minutos de acceso',
	freesample_notice_desc: 'Suscríbete a un paquete completo de League Pass para continuar teneniendo  acceso al contenido una vez que pasen tus {0} minutos.',
	freesample_notice_subscribe_button: 'Suscribir',
	freesample_notice_cancel_button: 'Cancelar en cualquier momento',
	freesample_popup_title: 'TU ACCESO HA TERMINADO',
	freesample_popup_subtitle: 'Suscríbete a League Pass para ver más excelente contenido de la NBA.',
	freesample_popup_link: '¡CONOCE MÁS!',
	freesample_popup_get_minutes_button: 'OBTÉN {0}  MINUTOS',

	// Video list
	reg_required_desc: 'Debes iniciar sesión para ver este contenido',
	favorite_teams_title: 'Equipos favoritos',
	bookmarked_title: 'Guardado',
	watch_history_title: 'Continuar viendo',
	game_schedule_title: 'Horario del partido',
	recommended_title: 'Recomendado',
	season_text: 'Temporada',

	// profile page
	section_information_title: 'Mis datos',
	section_information_desc: 'Actualiza tus datos personales',
	section_information_email: 'Correo electrónico',
	section_information_email_update: 'Actualizar la dirección de correo electrónico',
	section_information_password: 'Contraseña',
	section_information_password_update: 'Cambiar contraseña',
	section_information_social: 'Conexiones sociales',
	section_information_nosocial_message: 'No tienes ninguna cuenta vinculada.',
	section_information_firstname: 'Nombre',
	section_information_lastname: 'Apellidos',
	section_information_birth: 'Fecha de nacimiento',
	section_information_country: 'País/Región',
	section_information_postalcode: 'Código postal',
	section_information_edit: 'Editar',
	section_tv_provider_title: 'Mi proveedor de TV',
	section_tv_provider_desc: 'Obtén acceso a partidos en vivo y transmisiones de tu proveedor de televisión.',
	section_tv_provider_faq: 'Preguntas frecuentes sobre proveedores de TV',
	section_tv_provider_sign_out: 'Cerrar sesión',
	section_tv_provider_sign_in: 'Iniciar sesión en el proveedor de TV',
	section_fantasy_title: 'Fantasy',
	section_fantasy_desc: 'Ver la información de tu cuenta de Fantasy',
	section_fantasy_displayname: 'Nombre para mostrar',
	section_marketing_title: 'Mis preferencias de correo electrónico',
	section_marketing_desc: 'Accede a tus perferencias de marketing y de privacidad del usuario.',
	section_marketing_newsletters: 'Boletines',
	section_marketing_message: 'Mensajes y anuncios de la NBA',
	section_marketing_newsletters_desc_1: 'Noticias de la NBA enviadas a diario a tu correo.',
	section_marketing_newsletters_desc_2: 'Noticias y contenido de la NBA G League, la liga menor oficial de la NBA.',
	section_marketing_newsletters_desc_3: 'Noticias y contenido de la Jr. NBA, la iniciativa de baloncesto juvenil de la NBA.',
	section_marketing_newsletters_desc_4: 'Las últimas funciones de la aplicación de la NBA, además de actualizaciones y ofertas del League Pass.',
	section_marketing_newsletters_desc_5: 'Ofertas especiales de entradas, ofertas para socios, descuentos en eventos y artículos de la NBA.',
	section_marketing_newsletters_desc_6: 'Noticias y contenido de la NBA cuidadosamente seleccionados y enviados a tu correo todas las semanas.',
	section_marketing_newsletters_desc_7: 'Noticias y ofertas de la WNBA y de sus socios.',
	section_marketing_personal_title: 'Mis datos personales',
	section_marketing_personal_desc: 'Consiento que la NBA use mis datos personales para enviarme mensajes y anuncios sobre productos e iniciativas de la NBA y sus socios.',
	section_marketing_update_button: 'Actualizar las preferencias de marketing',
	section_marketing_update_success: 'Se han actualizado tus preferencias.',
	section_ccpa_title: 'No quiero que se vendan mis datos personales',

// profile edit modal
	email_modal_title: 'Actualizar la dirección de correo electrónico',
	email_modal_new_email_label: 'Nueva dirección de correo electrónico',
	email_modal_update: 'Actualizar',
	email_modal_cancel: 'Cancelar',
	password_modal_title: 'Cambiar contraseña',
	password_modal_current_label: 'Contraseña actual:',
	password_modal_new_label: 'Nueva contraseña:',
	password_modal_confirm_label: 'Confirmar contraseña',
	password_modal_update: 'Actualizar',
	password_modal_cancel: 'Cancelar',
	personal_modal_title: 'Actualizar los datos personales',
	personal_modal_email: 'Correo electrónico',
	personal_modal_password: 'Contraseña',
	personal_modal_birth: 'Fecha de nacimiento',
	personal_modal_social: 'Conexiones sociales',
	personal_modal_firstname: 'Nombre',
	personal_modal_lastname: 'Apellidos',
	personal_modal_country: 'País/Región',
	personal_modal_postalcode: 'Código postal',
	personal_modal_zipcode: 'Código postal',
	personal_modal_postalcode_invalid_message: 'Debe ser un código postal válido',
	personal_modal_zipcode_invalid_message: 'Debe ser un código postal válido',
	personal_modal_update: 'Actualizar',
	personal_modal_cancel: 'Cancelar',

	// payflow
	payflow_profile_name: 'Nombre',
	payflow_profile_email: 'Correo electrónico',

	// account page
	header_menu_account_my_account: 'Mi cuenta',
	header_menu_account_manage_account: 'Administrar cuenta',
	header_menu_account_favorite_teams: 'Equipos favoritos',
	header_menu_account_favorite_players: 'Jugadores favoritos',
	header_menu_account_viewing_history: 'Historial de visualización',
};
